import Vue from 'vue';
import colorSchemeComponent from './color-scheme';
Vue.component('ColorScheme', colorSchemeComponent);
var storageKey = 'nuxt-color-mode';
var colorMode = window['__NUXT_COLOR_MODE__'];
var getForcedColorMode = function getForcedColorMode(route) {
  return route.matched[0] && route.matched[0].components.default.options.colorMode;
};
export default function (ctx, inject) {
  var data = ctx.nuxtState ? ctx.nuxtState.colorMode : null;
  // For SPA mode or fallback
  if (!data) {
    data = {
      preference: colorMode.preference,
      value: colorMode.value,
      unknown: false
    };
    var pageColorMode = getForcedColorMode(ctx.route);
    if (pageColorMode) {
      data.value = pageColorMode;
      data.forced = true;
      colorMode.addClass(pageColorMode);
    }
  }
  // Get current page component
  var $colorMode = new Vue({
    data: data,
    watch: {
      preference: function preference(_preference) {
        if (this.forced) {
          return;
        }
        if (_preference === 'system') {
          this.value = colorMode.getColorScheme();
          this._watchMedia();
        } else {
          this.value = _preference;
        }
        this._storePreference(_preference);
      },
      value: function value(newValue, oldValue) {
        colorMode.removeClass(oldValue);
        colorMode.addClass(newValue);
      }
    },
    created: function created() {
      if (this.preference === 'system') {
        this._watchMedia();
      }
    },
    mounted: function mounted() {
      if (window.localStorage) {
        this._watchStorageChange();
      }
    },
    methods: {
      _watchMedia: function _watchMedia() {
        var _this = this;
        if (this._darkWatcher || !window.matchMedia) {
          return;
        }
        this._darkWatcher = window.matchMedia('(prefers-color-scheme: dark)');
        this._darkWatcher.addListener(function (e) {
          if (!_this.forced && _this.preference === 'system') {
            _this.value = colorMode.getColorScheme();
          }
        });
      },
      _watchStorageChange: function _watchStorageChange() {
        var _this2 = this;
        window.addEventListener('storage', function (e) {
          if (e.key === storageKey) {
            _this2.preference = e.newValue;
          }
        });
      },
      _storePreference: function _storePreference(preference) {
        // Local storage to sync with other tabs
        window.localStorage.setItem(storageKey, preference);
      }
    }
  });
  window.onNuxtReady(function () {
    if ($colorMode.unknown) {
      $colorMode.preference = colorMode.preference;
      $colorMode.value = colorMode.value;
      $colorMode.unknown = false;
    }
    ctx.app.router.beforeEach(function (route, from, next) {
      var forcedColorMode = getForcedColorMode(route);
      if (forcedColorMode && forcedColorMode !== 'system') {
        $colorMode.value = forcedColorMode;
        $colorMode.forced = true;
      } else {
        if (forcedColorMode === 'system') {
          console.warn('You cannot force the colorMode to system at the page level.');
        }
        $colorMode.forced = false;
        $colorMode.value = $colorMode.preference === 'system' ? colorMode.getColorScheme() : $colorMode.preference;
      }
      next();
    });
  });
  inject('colorMode', $colorMode);
}